import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SatelliteHeartbeatView } from "./SatelliteHeartbeatView";
import { SatelliteHeartbeatViewStore } from "../../store/SatelliteHeartbeatViewStore";
import { useStore } from "../../../../hooks";

export const SatelliteHeartbeatViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/satelliteHeartbeat/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SatelliteHeartbeatViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SatelliteHeartbeatView satelliteHeartbeatViewStore={store} />
      </PageLayout>
    </div>
  );
});
